/* eslint-disable no-param-reassign */

import ResourceManager from '@/services/resource.service';

const state = {
  resource: {
    List: {},
  },
};

// getters
const getters = {
  getResourceList (state) {
    // if (Object.keys(state.resource.List).length > 0)
    //   return state.resource.List
    // else {
    //   let packages = JSON.parse(localStorage.getItem("SystemResourceModel")).Packages
    //   let currentLang = JSON.parse(localStorage.getItem("SystemResourceModel")).CurrentLang
    //   return packages[currentLang].List
    // }
    return state.resource.List;
  },
  getCurrentLang () {
    return ResourceManager.CurrentLang;
  },
};

// mutations
const mutations = {
  setResource (state, value) {
    state.resource = value;
    if ('Proxy' in window) {
      const ignoreList = ['__ob__', '_isVue', 'Symbol(Symbol.toStringTag)'];

      state.resource.List = new Proxy(value.List, {
        get (obj, prop) {
          if (!ignoreList.some((item) => item === prop)
            && prop !== Symbol.toStringTag) return obj[prop] || prop;
        },
      });
    }
  },
};
// actions
const actions = {
  callSetResource (context, value) {
    context.commit('setResource', value);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
